import React, { useState } from 'react'
import {
  Grid,
  GridCell,
  PanelCollapsible,
  Divider,
  SpacingVertical
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import {
  DESKTOP,
  MOBILE,
  Preview,
  PREVIEW_SOCIAL
} from 'Pages/EmailContentDefaults/shared/Preview'

import { useRecoilValue } from 'recoil'
import {
  advancedPaddingState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import SocialMobile from './SocialMobile'
import SocialIconTheme from './SocialIconTheme'
import SocialBlockStyle from './SocialBlockStyle'
import SocialPadding from './SocialPadding'
import SocialElements from './SocialElements'

const Social = () => {
  const [collapsed, setSollapsed] = useState(true)
  const intl = useIntl()

  const { social } = useRecoilValue(styleState)

  // NON CANCELLARE
  const {
    // eslint-disable-next-line no-unused-vars
    paragraphDesktopPaddingAdvanced,
    // eslint-disable-next-line no-unused-vars
    paragraphMobilePaddingAdvanced
  } = useRecoilValue(advancedPaddingState)
  //* *************** */
  return (
    <>
      <PanelCollapsible
        onChange={() => setSollapsed(!collapsed)}
        collapsed={collapsed}
        title='Social'
        titleVariant='L'
      >
        <Grid>
          <GridCell span={8}>
            <SocialElements />
            <SocialIconTheme />
            <SocialBlockStyle />
            <SocialPadding />
          </GridCell>
          <GridCell span={4}>
            <Preview type={DESKTOP} preview={PREVIEW_SOCIAL} />
          </GridCell>
        </Grid>
        <Divider />
        <SpacingVertical />
        <Grid>
          <GridCell span={8}>
            <SocialMobile />
          </GridCell>
          <GridCell span={4}>
            <Preview type={MOBILE} preview={PREVIEW_SOCIAL} />
          </GridCell>
        </Grid>
      </PanelCollapsible>
    </>
  )
}

export default Social
